export default __webpack_public_path__ + "static/media/arrow.2dc9dd5b.svg";